import React from "react";
import LegacyFeaturedCaseStudiesSection from './legacy-featured-case-studies-section';

import { AnimateIn, Container, TitleSet } from "../ui-components";

/**
 * @component AssessmentCaseStudies
 * 
 * @prop {string} caseStudiesSectionTitle
 * @prop {array} featuredCaseStudies
 * 
 * @return {JSX}
 */
const AssessmentCaseStudies = ({ caseStudiesSectionTitle, featuredCaseStudies }) => {
  return (
    <AnimateIn onScroll>
      <Container id="caseStudies" sectionContainer>
        <TitleSet
          label={'Case Studies'}
          title={caseStudiesSectionTitle}
        />
        <LegacyFeaturedCaseStudiesSection caseStudies={featuredCaseStudies} />
      </Container>
    </AnimateIn>
  );
};

export { AssessmentCaseStudies };
